// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/sinalAdicionar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ESTILOS GERAIS */
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
body{
    width: 100vw;
    height: 100vh;
    font-family: Arial, Helvetica, sans-serif;
}
:root{
    --bg-white: #fff;
}
.layout{
    width: 100%;
    height: 100vh;
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: 
    "header header"
     "sidebar main"
     "sidebar footer";
}
header{
    grid-area: header;
}
aside{
    grid-area: sidebar;
}
main{
    grid-area: main;
}
footer{
    grid-area: footer;
    width: 100vw;
    grid-column: 1 / -1;
}
header,aside,main,footer{
    border: 1px solid #000;
}

/* ESTILOS DO HEADER */
header{
    width: 100%;
    padding: 20px 0;
    background-color: #808080;
}
header div img{
    width: 50px;
    height: 50px;
}
header div{
    display: flex;
    align-items: center;
    gap: 10px;
}
header h1{
    font-size: 2em;
    color: var(--bg-white);
}

/* ESTILOS DO SIDEBAR */
aside{
    width: 250px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #00ffff70;
}
aside h2{
    font-size: 1.5em;
    color: #000;
    margin: 10px 0 0 10px;
}
.container-add-todo-button button,
.container-project-button button{
    background-color: transparent;
    border: none;
    font-size: 1.02em;
}
.container-project-button{
    width: 225px;
    height: 45px;
    padding: 10px;
    margin-left: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
}
.container-project-button #button-add-project-sidebar{
    display: flex;
    align-items: center;
}
.icon-delete,
.icon-delete-todo,
.add-sign{
    width: 20px;
    height: 20px;
}
aside .container-project-button:hover{
    background-color: #808080a5;
    color: #fff;
}

/* ESTILOS DO MAIN */
main{
    width: 100%;
    padding: 20px;
    background-color: #87ceeb70;
}
.container-form-add-project,
.container-add-todo{
    width: 300px;
    height: 300px;
    border: 2px solid #000;
    border-radius: 10px;
    position: absolute;
}
.container-add-todo{
    top: 150px;
    left: 650px;
}
.container-form-add-project{
    display: none;
    top: 200px;
    left: 300px;
}
.container-add-todo-form,
.form-add-project{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.form-add-project h3,
.container-add-todo-form h3{
    font-size: 1.5em;
    color: #fff;
    width: 100%;
    text-align: center;
    border-radius: 10px 10px 0 0;
    background-color: #808080;
    padding: 15px 0;
}
.form-add-project label,
.container-add-todo-form label{
    font-size: 1.06em;
    font-weight: bold;
}
.form-add-project input,
.container-add-todo-form input{
    height: 30px;
    padding-left: 10px;
}
.container-buttons{
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}
.container-buttons button{
    width: 100px;
    height: 30px;
}
.hidden{
    display: none;
}

/* ESTILO DA TAREFA TAREFAS */
.todo-item{
    justify-content: space-between;
}
.todo-item,
.container-add-todo-button button{
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 25px 10px;
    border-radius: 10px;
}
#button-add-project-sidebar::before, 
.container-add-todo-button button::before{
    content: '';
    width: 20px;
    height: 20px;
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
    margin-right: 5px;
 }
.remove-todo{
    border: none;
    background-color: transparent;
}
.container-add-todo-button button{
    text-align: left;
}
.projects h3{
    margin-bottom: 20px;
}
.todo-item:hover, .container-add-todo-button button:hover{
    background-color: #808080;
    color: #fff;
}

/* ESTILOS DO FOOTER */
footer{
    width: 100vw;
    padding: 20px 0;
    background-color: #808080;
    text-align: center;
}
footer address p{
    font-size: 1.03em;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,aAAa;IACb,yCAAyC;AAC7C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,gCAAgC;IAChC,iCAAiC;IACjC;;;qBAGiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;AACA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;;IAGI,WAAW;IACX,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;AAC/B;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,UAAU;IACV,WAAW;AACf;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;;IAEI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;AACnB;AACA;;IAEI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;;IAEI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;IACI,8BAA8B;AAClC;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,4EAAuE;IACvE,iBAAiB;CACpB;AACD;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB","sourcesContent":["/* ESTILOS GERAIS */\n*{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\nbody{\n    width: 100vw;\n    height: 100vh;\n    font-family: Arial, Helvetica, sans-serif;\n}\n:root{\n    --bg-white: #fff;\n}\n.layout{\n    width: 100%;\n    height: 100vh;\n    display: grid;\n    grid-template-columns: 250px 1fr;\n    grid-template-rows: auto 1fr auto;\n    grid-template-areas: \n    \"header header\"\n     \"sidebar main\"\n     \"sidebar footer\";\n}\nheader{\n    grid-area: header;\n}\naside{\n    grid-area: sidebar;\n}\nmain{\n    grid-area: main;\n}\nfooter{\n    grid-area: footer;\n    width: 100vw;\n    grid-column: 1 / -1;\n}\nheader,aside,main,footer{\n    border: 1px solid #000;\n}\n\n/* ESTILOS DO HEADER */\nheader{\n    width: 100%;\n    padding: 20px 0;\n    background-color: #808080;\n}\nheader div img{\n    width: 50px;\n    height: 50px;\n}\nheader div{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\nheader h1{\n    font-size: 2em;\n    color: var(--bg-white);\n}\n\n/* ESTILOS DO SIDEBAR */\naside{\n    width: 250px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    background-color: #00ffff70;\n}\naside h2{\n    font-size: 1.5em;\n    color: #000;\n    margin: 10px 0 0 10px;\n}\n.container-add-todo-button button,\n.container-project-button button{\n    background-color: transparent;\n    border: none;\n    font-size: 1.02em;\n}\n.container-project-button{\n    width: 225px;\n    height: 45px;\n    padding: 10px;\n    margin-left: 10px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n.container-project-button #button-add-project-sidebar{\n    display: flex;\n    align-items: center;\n}\n.icon-delete,\n.icon-delete-todo,\n.add-sign{\n    width: 20px;\n    height: 20px;\n}\naside .container-project-button:hover{\n    background-color: #808080a5;\n    color: #fff;\n}\n\n/* ESTILOS DO MAIN */\nmain{\n    width: 100%;\n    padding: 20px;\n    background-color: #87ceeb70;\n}\n.container-form-add-project,\n.container-add-todo{\n    width: 300px;\n    height: 300px;\n    border: 2px solid #000;\n    border-radius: 10px;\n    position: absolute;\n}\n.container-add-todo{\n    top: 150px;\n    left: 650px;\n}\n.container-form-add-project{\n    display: none;\n    top: 200px;\n    left: 300px;\n}\n.container-add-todo-form,\n.form-add-project{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n.form-add-project h3,\n.container-add-todo-form h3{\n    font-size: 1.5em;\n    color: #fff;\n    width: 100%;\n    text-align: center;\n    border-radius: 10px 10px 0 0;\n    background-color: #808080;\n    padding: 15px 0;\n}\n.form-add-project label,\n.container-add-todo-form label{\n    font-size: 1.06em;\n    font-weight: bold;\n}\n.form-add-project input,\n.container-add-todo-form input{\n    height: 30px;\n    padding-left: 10px;\n}\n.container-buttons{\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n.container-buttons button{\n    width: 100px;\n    height: 30px;\n}\n.hidden{\n    display: none;\n}\n\n/* ESTILO DA TAREFA TAREFAS */\n.todo-item{\n    justify-content: space-between;\n}\n.todo-item,\n.container-add-todo-button button{\n    width: 100%;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    padding: 25px 10px;\n    border-radius: 10px;\n}\n#button-add-project-sidebar::before, \n.container-add-todo-button button::before{\n    content: '';\n    width: 20px;\n    height: 20px;\n    display: block;\n    background: url('./images/sinalAdicionar.png') center / cover no-repeat;\n    margin-right: 5px;\n }\n.remove-todo{\n    border: none;\n    background-color: transparent;\n}\n.container-add-todo-button button{\n    text-align: left;\n}\n.projects h3{\n    margin-bottom: 20px;\n}\n.todo-item:hover, .container-add-todo-button button:hover{\n    background-color: #808080;\n    color: #fff;\n}\n\n/* ESTILOS DO FOOTER */\nfooter{\n    width: 100vw;\n    padding: 20px 0;\n    background-color: #808080;\n    text-align: center;\n}\nfooter address p{\n    font-size: 1.03em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
